import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import role from "../../../../assets/svg/role.svg";
import dateIcon from "../../../../assets/svg/calendar-inside.svg";
import "react-datepicker/dist/react-datepicker.css";
import "date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import moment from "moment";
import note from "../../../../assets/svg/note.svg";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import submit from "../../../../assets/svg/submit.svg";
import UploadFile from "../../../../assets/svg/UploadFile.svg";
import UploadURL from "../../../../assets/svg/UploadURL.svg";
import UploadURLActive from "../../../../assets/svg/UploadURLActive.svg";
import UploadFileActive from "../../../../assets/svg/UploadFileActive.svg";
import SearchFileIcon from "../../../../assets/svg/Filesearch.svg";
import AttchementIcon from "../../../../assets/svg/AttchementIcon.svg";
import AttchCloseIcon from "../../../../assets/svg/AttchCloseIcon.svg";
import $ from "jquery";
import Autocomplete from "react-autocomplete";
import { rightBarClose, rightBarOpen } from "../../../../redux/action/Action";
import API from "../../../../helpers/endpointService";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FileIcon from "../../documents/folder/FileIcon";
import formats from "../../../../helpers/MediaFormats";
import { logoutFunction, CheckPasswordValid } from "../../../custom/commonFunction";
import lock from "../../../../assets/svg/lock.svg";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

var days = 1;

var SelectedValue1 = false;
var SelectedValue2 = false;

export default function UploadDocument({ rightbarOpen }) {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("UserId");
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);
  const [category1Default, setCategory1Default] = useState();
  const [category2Default, setCategory2Default] = useState();
  const [docNo, setDocNo] = useState();
  const [sumbitOne, setSubmitOne] = useState(true);
  const [document1selected, setDocument1Selected] = useState("1");
  const [document2selected, setDocument2Selected] = useState("1");
  const [document3selected, setDocument3Selected] = useState("1");
  const [document4selected, setDocument4Selected] = useState("1");
  const [document5selected, setDocument5Selected] = useState("1");
  const [Document1fromData, setDocument1fromData] = useState("");
  const [Document2fromData, setDocument2fromData] = useState("");
  const [Document3fromData, setDocument3fromData] = useState("");
  const [Document4fromData, setDocument4fromData] = useState("");
  const [Document5fromData, setDocument5fromData] = useState("");

  const [opencategory1List, setOpencategory1List] = useState(false);
  const [opencategory2List, setOpencategory2List] = useState(false);

  const [AuthorArrayList, setAuthorArrayList] = useState([]);
  const [openAuthorList, setOpenAuthorList] = useState(false);
  const [authorError, setAuthorError] = useState(false);
  const [valueChanged, setValueChanged] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [iswebMobile, setiswebMobile] = useState(false);
  const [isMobile, setisMobile] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);

  const [category2Change, setcategory2Change] = useState(false);

  const [category1, setCategory1] = useState(null);
  const [category2, setCategory2] = useState(null);
  const [isCategory1Empty, setCategory1Empty] = useState(false);
  const [isCategory2Empty, setCategory2Empty] = useState(false);
  const [isAuthorEmpty, setAuthorEmpty] = useState(false);
  const [Document1Size, setDocument1Size] = useState(0);
  const [Document2Size, setDocument2Size] = useState(0);
  const [Document3Size, setDocument3Size] = useState(0);
  const [Document4Size, setDocument4Size] = useState(0);
  const [Document5Size, setDocument5Size] = useState(0);
  const [users, setUsers] = useState([]);
  const [today, setToday] = useState(() => {
    const today = new Date();
    today?.setDate(today.getDate() + 1);
    return today?.toISOString().split("T")[0];
  });

  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [isPasswordProtected, setIsPasswordProtected] = useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const [document1Name, setDocument1Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 1,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document2Name, setDocument2Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 2,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document3Name, setDocument3Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 3,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document4Name, setDocument4Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 4,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });
  const [document5Name, setDocument5Name] = useState({
    isUrl: false,
    fileUrl: "",
    uniqueId: "",
    orderId: 5,
    IsSameFile: false,
    IsFileAdded: false,
    IsFilePresent: false,
    FileId: 0,
  });

  const renderUserTitle = (state, val) => {
    return state?.userName?.toLowerCase()?.indexOf(val?.toLowerCase()) !== -1;
  };

  const [inputData, setInputData] = useState({
    id: 0,
    documentName: "",
    revisedDocumentId: 0,
    documentNo: "",
    version: 0,
    category1Name: "",
    category2Name: "",
    category1Id: 0,
    category2Id: 0,
    authorId: 0,
    author: null,
    documentDate: "",
    createdDate: "",
    documentStatus: "",
    approvalStatus: "",
    reviewDate: "",
    remarks: "",
    reason: "",
  });
  const [isDocumentNoError, setIsDocumentNoError] = useState(false);

  const close = () => {
    clearfiles();
    dispatch(rightBarClose());

    $("body").removeClass("scrollhide");
  };

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }

    if (window.innerWidth < 400) {
      setiswebMobile(true);
    } else {
      setiswebMobile(false);
    }

    if (window.innerWidth < 300) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
  };

  useEffect(() => {
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    const fetchCategory1Data = async () => {
      let propApiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            fetchReviewers();
            setCategory1Default(
              response.data?.map((res) => {
                return {
                  value: res.categoryId,
                  label: res.categoryName,
                };
              })
            );
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchCategory1Data();

    ////////////////// Fetch Reviewers ///////////////////////
    const fetchReviewers = async () => {
      let reviewerApiUrl = `${API.GET_ALL_USERS}?includeAdmin=true`;
      await axios
        .get(reviewerApiUrl)
        .then((response) => {
          if (response?.status === 200) {
            setUsers(
              response.data?.map((res) => {
                return {
                  value: res.id,
                  label: res.userName,
                };
              })
            );
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };

    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  // useEffect(()=> {
  //     console.log(inputData)
  // },[inputData])

  /////////////////////////////////////// Fetch document number /////////////////////////////////////
  const fetchDocumentNo = async () => {
    axios({
      method: "POST",
      url: API.POST_NEW_DOCUMENT,
      data: {
        id: 0,
        category1Name: "",
        category2Name: "",
        category1Id: parseInt(category1?.value),
        category2Id: parseInt(category2?.value),
        documentId: 0,
        documentFormat: "",
        numberFormat: "",
      },
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setDocNo(response.data);
          if (
            response.data?.documentFormat === null &&
            response.data?.numberFormat === null
          ) {
            toast.warning("Ledger is not created for this category", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            });
            setIsDocumentNoError(true);
          }
        }
      })
      .catch((err) => {
        setDocNo("");
        logoutFunction(err?.response?.status);
      });
  };

  const fetchCategory2Data = async (id) => {
    let category2ApiUrl = `${API.POST_CATEGORIES}?category1Id=${id}`;

    axios({
      method: "POST",
      url: category2ApiUrl,
      data: null,
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setCategory2Default(
            response.data?.map((res) => {
              return {
                label: res.category2Name,
                value: res.category2Id,
              };
            })
          );
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
      });
  };

  useEffect(() => {
    setCategory2Default([]);
    setCategory2("");
  }, [category1]);

  useEffect(() => {
    if (category1 && category2) {
      fetchDocumentNo();
    } else {
      setDocNo("");
    }
  }, [category2Change]);

  ///////////////////////////////////////////// Handle input change //////////////////////////////////////////////

  //   const handleMyrequestInputChange = (e, field, fieldId) => {
  // SelectedValue1=false;
  //     if (e.target.value === "") {
  //       setInputData((prevData) => ({
  //         ...prevData,
  //         [`${field}Id`]: 0,
  //         [field]: e.target.value,
  //       }));

  //     } else {
  //       setInputData((prevData) => ({
  //         ...prevData,
  //         [`${field}Id`]: 0,
  //         [field]: e.target.value,
  //       }));
  //     }
  //   };

  const handleSelectChange = (value, field) => {
    SelectedValue1 = true;
    setInputData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleChange = (e, field) => {
    if (field === "reviewDate") {
      const inputDate = e;
      setInputData((prevData) => ({
        ...prevData,
        ["reviewDate"]: inputDate,
      }));
    } else {
      const { name, value } = e.target;
      setInputData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  /////////////////////////////////// Upload image /////////////////////////////////////////

  const clearfiles = () => {
    deletefiles1();
    deletefiles2();
    deletefiles3();
    deletefiles4();
    deletefiles5();
  };

  const toggleItems = [
    { name: UploadFile, name1: UploadFileActive, value: "1" },
    { name: UploadURL, name1: UploadURLActive, value: "2" },
  ];

  const checkvalidfile = (fileName) => {
    if (fileName) {
      const fileType = fileName?.split(".").pop().toLowerCase();
      const supportedFormats = Object.values(formats).flat();
      if (
        supportedFormats.includes(fileType) ||
        fileType === "heic" ||
        fileType === "mov"
      ) {
        return false;
      } else {
        toast.error(
          "The selected file format is not applicable. Please ensure the format and submit again",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          }
        );
        return true;
      }
    }
  };

  const CheckAlreadyExist = (filename, documentType) => {
    const FileAttachment = [];
    if (document1Name.fileUrl !== "" || document1Name.uniqueId !== "") {
      FileAttachment.push(document1Name);
    }
    if (document2Name.fileUrl !== "" || document2Name.uniqueId !== "") {
      FileAttachment.push(document2Name);
    }
    if (document3Name.fileUrl !== "" || document3Name.uniqueId !== "") {
      FileAttachment.push(document3Name);
    }
    if (document4Name.fileUrl !== "" || document4Name.uniqueId !== "") {
      FileAttachment.push(document4Name);
    }
    if (document5Name.fileUrl !== "" || document5Name.uniqueId !== "") {
      FileAttachment.push(document5Name);
    }
    if (filename) {
      const fileType = filename;
      if (FileAttachment?.length !== 0) {
        let Result = FileAttachment?.filter(
          (item) => item.uniqueId === fileType
        );
        if (Result?.length === 0) {
          return false;
        } else {
          if (documentType === "document1") {
            deletefiles1();
          }
          if (documentType === "document2") {
            deletefiles2();
          }
          if (documentType === "document3") {
            deletefiles3();
          }
          if (documentType === "document4") {
            deletefiles4();
          }
          if (documentType === "document5") {
            deletefiles5();
          }
          toast.warning(
            "The selected file is already uploaded. Please upload another file.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "colored",
            }
          );
          return true;
        }
      } else {
        return false;
      }
    }
  };

  const upload_document1 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document1");
        if (!isvalid && !isvalid1) {
          setDocument1Name({
            ...document1Name,
            [field]: file[0].name,
            orderId: 1,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument1fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document1");
        if (!isvalid && !isvalid1) {
          if (document1Name.FileId !== 0) {
            setDocument1Name({
              ...document1Name,
              [field]: file[0].name,
              orderId: 1,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument1Name({
              ...document1Name,
              [field]: file[0].name,
              orderId: 1,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument1fromData(file[0]);
        }
      }
    }
  };

  const upload_document2 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file?.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document2");
        if (!isvalid && !isvalid1) {
          setDocument2Name({
            ...document2Name,
            [field]: file[0].name,
            orderId: 2,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument2fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document2");
        if (!isvalid && !isvalid1) {
          if (document2Name.FileId !== 0) {
            setDocument2Name({
              ...document2Name,
              [field]: file[0].name,
              orderId: 2,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument2Name({
              ...document2Name,
              [field]: file[0].name,
              orderId: 2,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument2fromData(file[0]);
        }
      }
    }
  };

  const upload_document3 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document3");
        if (!isvalid && !isvalid1) {
          setDocument3Name({
            ...document3Name,
            [field]: file[0].name,
            orderId: 3,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument3fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document3");
        if (!isvalid && !isvalid1) {
          if (document3Name.FileId !== 0) {
            setDocument3Name({
              ...document3Name,
              [field]: file[0].name,
              orderId: 3,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument3Name({
              ...document3Name,
              [field]: file[0].name,
              orderId: 3,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument3fromData(file[0]);
        }
      }
    }
  };

  const upload_document4 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document4");
        if (!isvalid && !isvalid1) {
          setDocument4Name({
            ...document4Name,
            [field]: file[0].name,
            orderId: 4,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument4fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document4");
        if (!isvalid && !isvalid1) {
          if (document4Name.FileId !== 0) {
            setDocument4Name({
              ...document4Name,
              [field]: file[0].name,
              orderId: 4,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument4Name({
              ...document4Name,
              [field]: file[0].name,
              orderId: 4,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument4fromData(file[0]);
        }
      }
    }
  };

  const upload_document5 = (e, field, type) => {
    let file = e.target.files;
    if (type === "Submit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document5");
        if (!isvalid && !isvalid1) {
          setDocument5Name({
            ...document5Name,
            [field]: file[0].name,
            orderId: 5,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
          setDocument5fromData(file[0]);
        }
      }
    } else if (type === "Resubmit") {
      if (file.length > 0) {
        let isvalid = checkvalidfile(file[0].name);
        let isvalid1 = CheckAlreadyExist(file[0].name, "document5");
        if (!isvalid && !isvalid1) {
          if (document5Name.FileId !== 0) {
            setDocument5Name({
              ...document5Name,
              [field]: file[0].name,
              orderId: 5,
              IsSameFile: false,
              IsFileAdded: false,
              IsFilePresent: true,
            });
          } else {
            setDocument5Name({
              ...document5Name,
              [field]: file[0].name,
              orderId: 5,
              IsSameFile: false,
              IsFileAdded: true,
              IsFilePresent: true,
            });
          }
          setDocument5fromData(file[0]);
        }
      }
    }
  };

  function handleUrlTextchanges(e, type, field, Author) {
    if (Author === "Submit") {
      if (type === "document1") {
        setDocument1Name({
          ...document1Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document2") {
        setDocument2Name({
          ...document2Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document3") {
        setDocument3Name({
          ...document3Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document4") {
        setDocument4Name({
          ...document4Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      } else if (type === "document5") {
        setDocument5Name({
          ...document5Name,
          [field]: e.target.value,
          IsSameFile: false,
          IsFileAdded: true,
          IsFilePresent: true,
        });
      }
    } else if (Author === "Resubmit") {
      if (type === "document1") {
        if (document1Name.FileId !== 0) {
          setDocument1Name({
            ...document1Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument1Name({
            ...document1Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document2") {
        if (document2Name.FileId !== 0) {
          setDocument2Name({
            ...document2Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument2Name({
            ...document2Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document3") {
        if (document3Name.FileId !== 0) {
          setDocument3Name({
            ...document3Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument3Name({
            ...document3Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document4") {
        if (document4Name.FileId !== 0) {
          setDocument4Name({
            ...document4Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument4Name({
            ...document4Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      } else if (type === "document5") {
        if (document5Name.FileId !== 0) {
          setDocument5Name({
            ...document5Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: false,
            IsFilePresent: true,
          });
        } else {
          setDocument5Name({
            ...document5Name,
            [field]: e.target.value,
            IsSameFile: false,
            IsFileAdded: true,
            IsFilePresent: true,
          });
        }
      }
    }
  }

  const deletefiles1 = () => {
    if (document1selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    }
  };
  const deletefiles2 = () => {
    if (document2selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    }
  };
  const deletefiles3 = () => {
    if (document3selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3fromData("");
      setDocument3Size(0);
    }
  };
  const deletefiles4 = () => {
    if (document4selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    }
  };
  const deletefiles5 = () => {
    if (document5selected == "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    }
  };

  const handleToggle1 = (e) => {
    setDocument1Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 1,
        FileId: document1Name.FileId ? document1Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile1").val("");
      setDocument1Name(data);
      setDocument1fromData("");
      setDocument1Size(0);
    }
  };
  const handleToggle2 = (e) => {
    setDocument2Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 2,
        FileId: document2Name.FileId ? document2Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile2").val("");
      setDocument2Name(data);
      setDocument2fromData("");
      setDocument2Size(0);
    }
  };
  const handleToggle3 = (e) => {
    setDocument3Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3Size(0);
      setDocument3fromData("");
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 3,
        FileId: document3Name.FileId ? document3Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile3").val("");
      setDocument3Name(data);
      setDocument3Size(0);
      setDocument3fromData("");
    }
  };

  const handleToggle4 = (e) => {
    setDocument4Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 4,
        FileId: document4Name.FileId ? document4Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile4").val("");
      setDocument4Name(data);
      setDocument4fromData("");
      setDocument4Size(0);
    }
  };

  const handleToggle5 = (e) => {
    setDocument5Selected(e.currentTarget.value);
    if (e.currentTarget.value === "1") {
      let data = {
        isUrl: false,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    } else if (e.currentTarget.value === "2") {
      let data = {
        isUrl: true,
        fileUrl: "",
        uniqueId: "",
        orderId: 5,
        FileId: document5Name.FileId ? document5Name.FileId : 0,
        IsFileAdded: false,
        IsFilePresent: false,
        IsSameFile: false,
      };
      $("#inputGroupFile5").val("");
      setDocument5Name(data);
      setDocument5fromData("");
      setDocument5Size(0);
    }
  };

  ///////////////////////////////////////////// Submit Document ///////////////////////////////////////////

  const uploadSubmitMessage = () => {
    const inputs = document.querySelectorAll(".my-input-class[required]");
    const isValid = Array.from(inputs).every((input) => input.value !== "");
    const checkPassword = CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue);
    const inputs1 = document.querySelectorAll(".resubmit-autocomplete");
    const isValid2 =
      Array.from(inputs1).filter((input) => input.value === "")?.length > 0
        ? false
        : true;

    const removeBorder = Array.from(inputs1).filter(
      (input) => input.value != ""
    );

    removeBorder?.forEach((input) => {
      input.style.borderColor = "";
    });

    const category1Empty = !category1 || category1 === null;
    const category2Empty = !category2 || category2 === null;
    const authorEmpty = !inputData.author || inputData.author === null;

    setCategory1Empty(category1Empty);
    setCategory2Empty(category2Empty);
    setAuthorEmpty(authorEmpty);

    let myDateUTC;

    if (inputData.reviewDate) {
      let current = new Date();
      let h = current.getHours();
      let m = current.getMinutes();
      let s = current.getSeconds();
      let formattedTime = `${h.toString().padStart(2, "0")}:${m
        .toString()
        .padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
      let Newdate = moment(inputData.reviewDate).format("YYYY-MM-DD");
      var dataDate = Newdate;
      myDateUTC = dataDate;
      /*  let myDate = inputData.reviewDate + "T" + formattedTime;
       myDateUTC = new Date(myDate).toISOString(); */
    }
    if (
      isValid &&
      docNo?.numberFormat !== null &&
      isValid2 &&
      !category1Empty &&
      !category2Empty &&
      !authorEmpty &&
      checkPassword
    ) {
      setSubmitOne(false);
      setPropertyLoader(true);
      //   //setispendingLoader(true);
      const FileAttachment = [];
      if (document1Name.fileUrl !== "" || document1Name.uniqueId !== "") {
        FileAttachment.push(document1Name);
      }
      if (document2Name.fileUrl !== "" || document2Name.uniqueId !== "") {
        FileAttachment.push(document2Name);
      }
      if (document3Name.fileUrl !== "" || document3Name.uniqueId !== "") {
        FileAttachment.push(document3Name);
      }
      if (document4Name.fileUrl !== "" || document4Name.uniqueId !== "") {
        FileAttachment.push(document4Name);
      }
      if (document5Name.fileUrl !== "" || document5Name.uniqueId !== "") {
        FileAttachment.push(document5Name);
      }

      let UploadformData = new FormData();
      if (Document1fromData !== "") {
        UploadformData.append("files", Document1fromData);
      }
      if (Document2fromData !== "") {
        UploadformData.append("files", Document2fromData);
      }
      if (Document3fromData !== "") {
        UploadformData.append("files", Document3fromData);
      }
      if (Document4fromData !== "") {
        UploadformData.append("files", Document4fromData);
      }
      if (Document5fromData !== "") {
        UploadformData.append("files", Document5fromData);
      }
      UploadformData.append("fileitem", JSON.stringify(FileAttachment));

      const dataItem = {
        id: 0,
        documentName: inputData.documentName,
        documentNo: docNo?.numberFormat,
        version: 1,
        category1Name: category1?.label,
        category2Name: category2?.label,
        category1Id: parseInt(category1?.value),
        category2Id: parseInt(category2?.value),
        authorId: parseInt(inputData.author?.value) || 0,
        authorName: inputData.author?.label || null,
        reviewDate: myDateUTC || null,
        remarks: inputData.remarks,
        isPasswordProtected: isPasswordProtected,
        password: isPasswordProtected == true ? window.btoa(newPasswordValue) : "",
      };
      UploadformData.append("dataitem", JSON.stringify(dataItem));

      if (FileAttachment?.length > 0) {
        let FileAttachmentLength = 0;
        if (Document1fromData !== "") {
          FileAttachmentLength = Document1fromData.size;
        }
        if (Document2fromData !== "") {
          FileAttachmentLength = FileAttachmentLength
            ? FileAttachmentLength + Document2fromData.size
            : Document2fromData.size;
        }
        if (Document3fromData !== "") {
          FileAttachmentLength = FileAttachmentLength
            ? FileAttachmentLength + Document3fromData.size
            : Document3fromData.size;
        }
        if (Document4fromData !== "") {
          FileAttachmentLength = FileAttachmentLength
            ? FileAttachmentLength + Document4fromData.size
            : Document4fromData.size;
        }
        if (Document5fromData !== "") {
          FileAttachmentLength = FileAttachmentLength
            ? FileAttachmentLength + Document5fromData.size
            : Document5fromData.size;
        }
        if (FileAttachmentLength < 30000000) {
          let apiUrl = `${API.POST_UPLOAD_DOCUMENTS}?userId=${userId}`;
          axios({
            method: "POST",
            url: apiUrl,
            headers: {
              "content-type": "multipart/form-data",
            },
            data: UploadformData,
          })
            .then((res) => {
              // setSubmitOne(true)
              if (res.status === 200) {
                toast.success("Submitted successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                clearfiles();
                $("#AuthorSubmissionScreen").removeClass("show");
                $("body").removeClass("scrollhide");
              }
              dispatch(rightBarClose());
              setPropertyLoader(false);
            })
            .catch((err) => {
              dispatch(rightBarClose());
              setPropertyLoader(false);
              logoutFunction(err?.response?.status);
            });
        } else {
          setPropertyLoader(false);
          toast.error("Please upload the files below 30MB.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
      } else {
        setSubmitOne(true);
        setPropertyLoader(false);
        toast.warning("Upload atleast one file", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      // setSubmitOne(true)
      setPropertyLoader(false);
    }

    const viewbar = document.getElementById("viewbar");

    if (!docNo?.numberFormat) {
      document.getElementById("dno").style.borderBottom = "1px solid red";
      toast.warning("Ledger is not created for this category", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      viewbar.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } else {
      document.getElementById("dno").style.borderBottom = "none";
    }

    const inputs2 = document.querySelectorAll(".my-input-class[required]");
    const emptyInputs = Array.from(inputs2).filter(
      (input) => input.value === ""
    );

    const inputs3 = document.querySelectorAll(".resubmit-autocomplete");
    const emptyInputs1 = Array.from(inputs3).filter(
      (input) => input.value === ""
    );

    if (emptyInputs?.length > 0) {
      viewbar.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      emptyInputs.forEach((input) => {
        input.style.borderColor = "red";

        input.addEventListener("input", () => {
          if (input.value !== "") {
            input.style.borderColor = "";
          }
        });
      });
    }
    if (emptyInputs1?.length > 0) {
      viewbar.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      emptyInputs1.forEach((input) => {
        input.style.borderColor = "red";

        input.addEventListener("input", () => {
          if (input.value !== "") {
            input.style.borderColor = "";
          }
        });
      });
    }
  };

  const handleSelectCategoryChange = (value, field) => {
    SelectedValue2 = true;
    if (field === "category1Name") {
      setPropertyLoader(true);
      setPropertyFailed(false);
      setCategory1(value);

      if (value) {
        fetchCategory2Data(value?.value);
      }
      setCategory2("");
      setPropertyLoader(false);
      setPropertyFailed(false);
    } else if (field === "category2Name") {
      setcategory2Change(!category2Change);
      setCategory2(value);
    }
  };

  const HandleFileOpen=(id)=>{
      const fileInput = document.getElementById(id);
    fileInput.click();
  }

  const handleCheckboxChange = (event) => {
    setIsPasswordProtected(event.target.checked);
  };

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  return (
    <>
      <div
        id="viewbar"
        className={`viewbar newDocument ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        {isPropertyFailed && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <span>Loading failed</span>
            </div>
          </div>
        )}

        <div className="viewMain">
          <div className="viewTitle">
            <span>Upload document</span>
            {!isPropertyLoader && (
              <span className="close mt-2" onClick={close}>
                ✕
              </span>
            )}
          </div>
          {category1Default && (
            <>
              <div>
                <div className="row mt-2">
                  <div className={`col-sm-6 col-12`}>
                    <div className="inputTitle mt-2 commonsearch-field">
                      <img src={role} alt="" />
                      <span>
                        {" "}
                        Category 1&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <div className="mt-1">
                      <Select
                        className={`text-12-normal ${
                          isCategory1Empty ? "error" : ""
                        }`}
                        classNamePrefix="assigngroups"
                        value={category1}
                        options={category1Default}
                        defaultValue={category1 || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          handleSelectCategoryChange(e, "category1Name")
                        }
                      />
                    </div>
                  </div>

                  <div className={`col-sm-6 col-12 topfield`}>
                    <div className="inputTitle mt-2 commonsearch-field">
                      <img src={role} alt="" />
                      <span>
                        {" "}
                        Category 2&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <div className="mt-1">
                      <Select
                        className={`text-12-normal ${
                          isCategory2Empty ? "error" : ""
                        }`}
                        classNamePrefix="assigngroups"
                        value={category2}
                        isDisabled={!category1}
                        options={category2Default}
                        defaultValue={category2 || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) =>
                          handleSelectCategoryChange(e, "category2Name")
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-sm-6 col-12 d-flex flex-column " id="dno">
                    <div className="inputTitle commonsearch-field">
                      <span>
                        <img
                          style={{ position: "relative", top: "-1px" }}
                          src={infoBlack}
                          alt=""
                        />{" "}
                        Document no.
                      </span>
                    </div>
                    <span
                      className="mt-1"
                      style={{
                        fontWeight: "400",
                        color: "#605E5C",
                        paddingLeft: "2px",
                        fontSize:"12px"
                      }}
                    >
                      {docNo?.documentFormat && docNo?.numberFormat? docNo?.documentFormat+docNo?.numberFormat:"-"}
                      {/* {docNo?.documentFormat || "-"}
                      {docNo?.numberFormat || "-"} */}
                    </span>
                  </div>
                  <div className="col-sm-6 col-12 topfield">
                    <div className="inputTitle commonsearch-field">
                      <img src={file} alt="" />
                      <span>
                        {" "}
                        Document name&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <input
                      style={{ fontSize: "12px" }}
                      name="documentName"
                      value={inputData.documentName}
                      onChange={(e) => handleChange(e)}
                      maxLength={255}
                      className="form-control my-input-class border-radius shiptype-select mt-2 dropdown-height"
                      required
                    />
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-sm-6 col-12">
                    {isDocumentNoError && (
                      <span className="Error-msg">
                        ledger is not created for this category
                      </span>
                    )}
                  </div>
                </div> */}
                <div className="row mt-3">
                  <div
                    className={`col-sm-6 col-12`}
                    style={{ marginTop: "1px" }}
                  >
                    <div className="inputTitle  commonsearch-field">
                      <img src={role} alt="" />
                      <span>
                        {" "}
                        Author&nbsp;<span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <div className="mt-1">
                      <Select
                        className={`text-12-normal ${
                          isAuthorEmpty ? "error" : ""
                        }`}
                        classNamePrefix="assigngroups"
                        value={inputData.author}
                        options={users}
                        defaultValue={inputData.author || "Select"}
                        isMulti={false}
                        isSearchable={true}
                        isClearable={true}
                        onChange={(e) => handleSelectChange(e, "author")}
                      />
                    </div>
                  </div>

                  <div
                    className="col-sm-6 col-12 topfield"
                    //style={{ marginTop: "12px" }}
                  >
                    <div className="inputTitle date-bottom commonsearch-field">
                      <img src={calender} alt="" />
                      <span> Expiry date</span>
                    </div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control date-input-class upload-expiry-date-height border-radius shiptype-select mt-1 f-12"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={<img src={dateIcon} />}
                        minDate={new Date(
                          Date.now() + days * 24 * 60 * 60 * 1000
                        ).toString()}
                        format="dd-MMM-yyyy"
                        value={
                          inputData.reviewDate ? inputData.reviewDate : null
                        }
                        size="small"
                        onChange={(e) => handleChange(e, "reviewDate")}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>

              <div className="row mt-1">
                <div
                  className={`col-sm-6 col-12 mb-2 ${
                    isSmallMobile ? "" : "mt-2"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-search-img"
                        src={SearchFileIcon}
                      />{" "}
                      <span className="pl-10 properties-search-span">
                        File 1
                      </span>
                      &nbsp;
                    </label>
                    {document1selected == "1" ? (
                      <div class="input-group attach-style mt-2">
                        <div class="d-flex w-100">
                          <label
                            class={`file-label-style mb-2 ${
                              document1Name.uniqueId != "" ? "file-select" : ""
                            }`}
                            aria-describedby="inputGroupFileAddon"
                          >
                            {document1Name.uniqueId != "" && (
                              <>
                                {" "}
                                <i className="FileIcon-img">
                                  <FileIcon fileName={document1Name.uniqueId} />
                                </i>
                                <span>{document1Name.uniqueId}</span>
                                <i onClick={deletefiles1}>
                                  <img
                                    alt=""
                                    class="mx-auto FileIcon-cross"
                                    src={AttchCloseIcon}
                                  />
                                </i>{" "}
                              </>
                            )}
                          </label>
                          <div class="custom-file-input" onClick={()=>HandleFileOpen("inputGroupFile1")}>
                          <input
                            type="file"
                            hidden
                            id="inputGroupFile1"
                            onChange={(e) =>
                              upload_document1(e, "uniqueId", "Resubmit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon} 
                            //onClick={()=>HandleFileOpen("inputGroupFile1")}
                          ></img>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="text"
                        class="form-control input-style mt-2"
                        value={document1Name.fileUrl}
                        maxLength={255}
                        onChange={(e) =>
                          handleUrlTextchanges(
                            e,
                            "document1",
                            "fileUrl",
                            "Resubmit"
                          )
                        }
                      />
                    )}

                    <div className="toggle-btn-grp mt-2">
                      {toggleItems?.map((item, index) => (
                        <>
                          <input
                            type="radio"
                            name="options-outlined"
                            className="fileToggler"
                            id={`toggleItem1${index}`}
                            value={item.value}
                            checked={document1selected == item.value}
                            autocomplete="off"
                            onClick={(e) => handleToggle1(e)}
                          />
                          <label
                            className={`btn toggle-btn mb-0 ${
                              document1selected == item.value
                                ? "toggle-active"
                                : ""
                            }`}
                            for={`toggleItem1${index}`}
                          >
                            <img
                              alt=""
                              className="toggle-img"
                              src={
                                document1selected == item.value
                                  ? item.name1
                                  : item.name
                              }
                            />
                          </label>
                        </>
                      ))}
                    </div>
                  </div>
                </div>

                <div
                  className={`col-sm-6 col-12 mb-2 ${
                    isSmallMobile ? "" : "mt-2"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-search-img"
                        src={SearchFileIcon}
                      />{" "}
                      <span className="pl-10 properties-search-span">
                        File 2
                      </span>
                      &nbsp;
                    </label>
                    {document2selected == "1" ? (
                      <div class="input-group attach-style mt-2">
                        <div class="d-flex w-100">
                          <label
                            class={`file-label-style mb-2 ${
                              document2Name.uniqueId != "" ? "file-select" : ""
                            }`}
                            aria-describedby="inputGroupFileAddon"
                          >
                            {document2Name.uniqueId != "" && (
                              <>
                                {" "}
                                <i className="FileIcon-img">
                                  <FileIcon fileName={document2Name.uniqueId} />
                                </i>
                                <span>{document2Name.uniqueId}</span>
                                <i onClick={deletefiles2}>
                                  <img
                                    alt=""
                                    class="mx-auto FileIcon-cross"
                                    src={AttchCloseIcon}
                                  ></img>
                                </i>{" "}
                              </>
                            )}
                          </label>
                          <div class="custom-file-input" onClick={()=>HandleFileOpen("inputGroupFile2")}>
                          <input
                            type="file"
                            hidden
                            id="inputGroupFile2"
                            onChange={(e) =>
                              upload_document2(e, "uniqueId", "Resubmit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon}
                          ></img>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="text"
                        class="form-control input-style mt-2"
                        value={document2Name.fileUrl}
                        maxLength={255}
                        onChange={(e) =>
                          handleUrlTextchanges(
                            e,
                            "document2",
                            "fileUrl",
                            "Resubmit"
                          )
                        }
                      />
                    )}
                    <div className="toggle-btn-grp mt-2">
                      {toggleItems?.map((item, index) => (
                        <>
                          <input
                            type="radio"
                            name="options-outlined"
                            className="fileToggler"
                            value={item.value}
                            id={`toggleItem2${index}`}
                            checked={document2selected == item.value}
                            autocomplete="off"
                            onClick={(e) => handleToggle2(e)}
                          />
                          <label
                            className={`btn toggle-btn mb-0 ${
                              document2selected == item.value
                                ? "toggle-active"
                                : ""
                            }`}
                            for={`toggleItem2${index}`}
                          >
                            <img
                              alt=""
                              className="toggle-img"
                              src={
                                document2selected == item.value
                                  ? item.name1
                                  : item.name
                              }
                            />
                          </label>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  className={`col-sm-6 col-12 mb-2 ${
                    isSmallMobile ? "" : "mt-2"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-search-img"
                        src={SearchFileIcon}
                      />{" "}
                      <span className="pl-10 properties-search-span">
                        File 3
                      </span>
                      &nbsp;
                    </label>
                    {document3selected == "1" ? (
                      <div class="input-group attach-style mt-2">
                        <div class="d-flex w-100">
                          <label
                            class={`file-label-style mb-2 ${
                              document3Name.uniqueId != "" ? "file-select" : ""
                            }`}
                            aria-describedby="inputGroupFileAddon"
                          >
                            {document3Name.uniqueId != "" && (
                              <>
                                {" "}
                                <i className="FileIcon-img">
                                  <FileIcon fileName={document3Name.uniqueId} />
                                </i>
                                <span>{document3Name.uniqueId}</span>
                                <i onClick={deletefiles3}>
                                  <img
                                    alt=""
                                    class="mx-auto FileIcon-cross"
                                    src={AttchCloseIcon}
                                  ></img>
                                </i>{" "}
                              </>
                            )}
                          </label>
                          <div class="custom-file-input" onClick={()=>HandleFileOpen("inputGroupFile3")}>
                          <input
                            type="file"
                            id="inputGroupFile3"
                            hidden
                            onChange={(e) =>
                              upload_document3(e, "uniqueId", "Resubmit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon}
                          ></img>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="text"
                        class="form-control input-style mt-2"
                        value={document3Name.fileUrl}
                        maxLength={255}
                        onChange={(e) =>
                          handleUrlTextchanges(
                            e,
                            "document3",
                            "fileUrl",
                            "Resubmit"
                          )
                        }
                      />
                    )}
                    <div className="toggle-btn-grp mt-2">
                      {toggleItems?.map((item, index) => (
                        <>
                          <input
                            type="radio"
                            name="options-outlined"
                            className="fileToggler"
                            id={`toggleItem3${index}`}
                            value={item.value}
                            checked={document3selected == item.value}
                            autocomplete="off"
                            onClick={(e) => handleToggle3(e)}
                          />
                          <label
                            className={`btn toggle-btn mb-0 ${
                              document3selected == item.value
                                ? "toggle-active"
                                : ""
                            }`}
                            for={`toggleItem3${index}`}
                          >
                            <img
                              alt=""
                              className="toggle-img"
                              src={
                                document3selected == item.value
                                  ? item.name1
                                  : item.name
                              }
                            />
                          </label>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  className={`col-sm-6 col-12 mb-2 ${
                    isSmallMobile ? "" : "mt-2"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-search-img"
                        src={SearchFileIcon}
                      />{" "}
                      <span className="pl-10 properties-search-span">
                        File 4
                      </span>
                      &nbsp;
                    </label>
                    {document4selected == "1" ? (
                      <div class="input-group attach-style mt-2">
                        <div class="d-flex w-100">
                          <label
                            class={`file-label-style mb-2 ${
                              document4Name.uniqueId != "" ? "file-select" : ""
                            }`}
                            aria-describedby="inputGroupFileAddon"
                          >
                            {document4Name.uniqueId != "" && (
                              <>
                                {" "}
                                <i className="FileIcon-img">
                                  <FileIcon fileName={document4Name.uniqueId} />
                                </i>
                                <span>{document4Name.uniqueId}</span>
                                <i onClick={deletefiles4}>
                                  <img
                                    alt=""
                                    class="mx-auto FileIcon-cross"
                                    src={AttchCloseIcon}
                                  ></img>
                                </i>{" "}
                              </>
                            )}
                          </label>
                          <div class="custom-file-input" onClick={()=>HandleFileOpen("inputGroupFile4")}>
                          <input
                            type="file"
                            id="inputGroupFile4"
                            hidden
                            onChange={(e) =>
                              upload_document4(e, "uniqueId", "Resubmit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon}
                          ></img>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="text"
                        class="form-control input-style mt-2"
                        value={document4Name.fileUrl}
                        maxLength={255}
                        onChange={(e) =>
                          handleUrlTextchanges(
                            e,
                            "document4",
                            "fileUrl",
                            "Resubmit"
                          )
                        }
                      />
                    )}
                    <div className="toggle-btn-grp mt-2">
                      {toggleItems?.map((item, index) => (
                        <>
                          <input
                            type="radio"
                            name="options-outlined"
                            className="fileToggler"
                            id={`toggleItem4${index}`}
                            value={item.value}
                            checked={document4selected == item.value}
                            autocomplete="off"
                            onClick={(e) => handleToggle4(e)}
                          />
                          <label
                            className={`btn toggle-btn mb-0 ${
                              document4selected == item.value
                                ? "toggle-active"
                                : ""
                            }`}
                            for={`toggleItem4${index}`}
                          >
                            <img
                              alt=""
                              className="toggle-img"
                              src={
                                document4selected == item.value
                                  ? item.name1
                                  : item.name
                              }
                            />
                          </label>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  className={`col-sm-6 col-12 mb-2 ${
                    isSmallMobile ? "" : "mt-2"
                  }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex m-0 label-text ${
                        isMobile ? "pt-2" : ""
                      }`}
                    >
                      <img
                        alt=""
                        className="properties-search-img"
                        src={SearchFileIcon}
                      />{" "}
                      <span className="pl-10 properties-search-span">
                        File 5
                      </span>
                      &nbsp;
                    </label>
                    {document5selected == "1" ? (
                      <div class="input-group attach-style mt-2">
                        <div class="d-flex w-100">
                          <label
                            class={`file-label-style ${
                              document5Name.uniqueId != "" ? "file-select" : ""
                            }`}
                            aria-describedby="inputGroupFileAddon"
                          >
                            {document5Name.uniqueId != "" && (
                              <>
                                {" "}
                                <i className="FileIcon-img">
                                  <FileIcon fileName={document5Name.uniqueId} />
                                </i>
                                <span>{document5Name.uniqueId}</span>
                                <i onClick={deletefiles5}>
                                  <img
                                    alt=""
                                    class="mx-auto FileIcon-cross"
                                    src={AttchCloseIcon}
                                  ></img>
                                </i>{" "}
                              </>
                            )}
                          </label>
                          <div class="custom-file-input" onClick={()=>HandleFileOpen("inputGroupFile5")}>
                          <input
                            type="file"
                            id="inputGroupFile5"
                            hidden
                            onChange={(e) =>
                              upload_document5(e, "uniqueId", "Resubmit")
                            }
                          />
                          <img
                            alt=""
                            class="attchement-icon mx-auto"
                            src={AttchementIcon}
                          ></img>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <input
                        type="text"
                        class="form-control input-style mt-2"
                        value={document5Name.fileUrl}
                        maxLength={255}
                        onChange={(e) =>
                          handleUrlTextchanges(
                            e,
                            "document5",
                            "fileUrl",
                            "Resubmit"
                          )
                        }
                      />
                    )}
                    <div className="toggle-btn-grp mt-2">
                      {toggleItems?.map((item, index) => (
                        <>
                          <input
                            type="radio"
                            name="options-outlined"
                            className="fileToggler"
                            id={`toggleItem5${index}`}
                            value={item.value}
                            checked={document5selected == item.value}
                            onClick={(e) => handleToggle5(e)}
                          />
                          <label
                            className={`btn toggle-btn mb-0 ${
                              document5selected == item.value
                                ? "toggle-active"
                                : ""
                            }`}
                            for={`toggleItem5${index}`}
                          >
                            <img
                              alt=""
                              className="toggle-img"
                              src={
                                document5selected == item.value
                                  ? item.name1
                                  : item.name
                              }
                            />
                          </label>
                        </>
                      ))}
                    </div>
                  </div>
                </div>

                <div
                  className={`col-sm-6 col-12 mt-2 ${isMobile ? "" : "pb-3"} `}
                >
                  <div className="form-group"></div>
                </div>

                <div className="inputSection mt-2">
                  <div className="row">
                    <div className="col-12 mt-1">
                      <div className="inputTitle">
                        <img src={note} alt="" />
                        <span> Note</span>
                      </div>
                      <textarea
                        value={inputData.remarks}
                        name="remarks"
                        style={{ fontSize: "12px", height: "80px" }}
                        onChange={(e) => handleChange(e)}
                        className="form-control border-radius shiptype-select mt-2"
                      />
                    </div>
                  </div>

                  <div className="row">
                <div className="col-12 mt-3">
                  <div className="inputTitle commonsearch-field">
                    <input
                      type="checkbox"
                      className="password-checkbox"
                      name="request"
                      onChange={(e) => handleCheckboxChange(e)}
                    />
                    <span className="password-text pt-1">
                      Is password protected?
                    </span>
                  </div>
                </div>
              </div>
              {isPasswordProtected && (
                <div className="row">
                  <div className="col-12 mt-3">
                    <div className="inputTitle commonsearch-field">
                      <img src={lock} className="password-icon" alt="" />
                      <span>
                        {" "}
                        New password&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <FormControl variant="outlined" className="w-100 mt-2">
                      <OutlinedInput
                        className="password-inputs newdoc-newpassword"
                        id="newdoc-newpasswordid"
                        value={newPasswordValue}
                        onChange={(e) => setNewPasswordValue(e.target.value)}
                        type={showNewPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              edge="end"
                            >
                              {showNewPassword ? (
                                <VisibilityOff className="eye-password-icon" />
                              ) : (
                                <Visibility className="eye-password-icon" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="mt-0 font-13">
                      <span
                        className="required-color font-weight400 newPasswordErrorText"
                        id="newPasswordErrorText"
                      ></span>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="inputTitle commonsearch-field">
                      <img src={lock} className="password-icon" alt="" />
                      <span>
                        {" "}
                        Confirm password&nbsp;
                        <span style={{ color: "#ee192d" }}>*</span>
                      </span>
                    </div>
                    <FormControl variant="outlined" className="w-100 mt-2">
                      <OutlinedInput
                        className="password-inputs newdoc-confirmpassword"
                        id="newdoc-confirmpasswordid"
                        value={confirmPasswordValue}
                        onChange={(e) =>
                          setConfirmPasswordValue(e.target.value)
                        }
                        type={showConfirmPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff className="eye-password-icon" />
                              ) : (
                                <Visibility className="eye-password-icon" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="mt-0 font-13">
                      <span
                        className="required-color font-weight400 confirmPasswordErrorText"
                        id="confirmPasswordErrorText"
                      ></span>
                    </div>
                  </div>
                </div>
              )}

                  {hasError && (
                    <div className="mt-1">
                      <span style={{ color: "red" }}>
                        Input values has duplicates
                      </span>
                    </div>
                  )}

                  <div className="button mt-4">
                    <button id="edit" onClick={uploadSubmitMessage}>
                      <img
                        style={{
                          marginTop: "-4px",
                          marginRight: "4px",
                          width: "14px",
                        }}
                        src={submit}
                        alt=""
                      />
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
